import { Link } from 'react-router';

import { CircleHelp } from 'lucide-react';

import config from '@/utils/config';
import Separator from '@/components/ui/Seperator';

const LoginPageFooter = () => {
  return (
    <div className='flex max-w-full flex-col justify-center gap-10'>
      <div className='versions flex flex-wrap items-center justify-center gap-x-14 gap-y-5'>
        <span className='text-lg font-medium text-stone-400'>
          Version {config.version.toFixed(1)}
        </span>
        <Link
          to='#'
          className='text-lg font-medium text-stone-400'
        >
          Changelogs
        </Link>
        <Link
          to='#'
          className='text-lg font-medium text-stone-400'
        >
          Roadmap
        </Link>
      </div>
      <Separator />
      <div className='support text-center'>
        <Link
          to='#'
          className='inline-flex items-center gap-2 text-lg font-medium text-stone-400'
        >
          <CircleHelp size={20} /> Help & Support
        </Link>
      </div>
    </div>
  );
};

export default LoginPageFooter;
